

export const carrieReviewerReviewHinge = {
  _id: 'carrieReviewerReviewHingeId',
  email: 'carrie@email.com',
  profileReviewId: 'carrieProfileReviewHingeId',
  reviewerProfileId: 'carrieReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Carrie! This will really help me!',
  profileReviewedFirstName: 'Charlotte',
}

export const mirandaReviewerReviewBumble = {
  _id: 'mirandaReviewerReviewBumbleId',
  email: 'miranda@email.com',
  profileReviewId: 'mirandaProfileReviewBumbleId',
  reviewerProfileId: 'mirandaReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Miranda! This will really help me!',
  profileReviewedFirstName: 'Charlotte',
}

export const samanthaReviewerReviewTinder = {
  _id: 'samanthaReviewerReviewTinderId',
  email: 'samantha@email.com',
  profileReviewId: 'samanthaProfileReviewTinderId',
  reviewerProfileId: 'samanthaReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Samantha! This will really help me!',
  profileReviewedFirstName: 'Charlotte',
}